module.exports = __webpack_public_path__ + "img/background_03.1e220cbf.png";